import * as React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import { GatsbyImage, StaticImage } from 'gatsby-plugin-image'
import useCDNImage from '../../hooks/useCDNImage'
import { gridSizes } from '../../common/gatsbyImageData'
import ThemedSection, { isDark } from './ThemedSection'
import { InlineSectionHeading } from './SectionHeading'

export const ParagraphStickyImageSection = ({ section }) => {
  const { heading, content, fields, images, theme, layout } = section
  const finalImage = useCDNImage((images||[])[0], { productType: 'Mens Watch' }, gridSizes, '50vw')
  let paragraphWithUpdatedImages
  paragraphWithUpdatedImages = fields ? fields.contentImg : null
  const htmlToRender = paragraphWithUpdatedImages ? paragraphWithUpdatedImages : content
  const contentHtml = {
    __html: (heading ? InlineSectionHeading(heading) : '') + htmlToRender,
  }

  return (
    <ThemedSection theme={theme}>
      <section className="grid grid-cols-1 xl:grid-cols-2 w-10/12 xl:w-full max-w-[1366px] mx-auto  gap-2 relative justify-start items-center ">
        <div className={'xl:sticky top-0' + (layout === 'Image Right' ? ' order-2' : '')}>
          {finalImage ? (
            <GatsbyImage
              image={finalImage?.gatsbyImageData}
              alt={heading}
              className=""
              imgStyle={{ objectFit: 'contain' }}
            />
          ) : (
            <StaticImage
              alt={heading}
              src="../../images/404-page-not-found.jpg"
              className=""
              imgStyle={{ objectFit: 'contain' }}
            />
          )}
        </div>
        <div
          className={
            'leading-loose px-5 prose lg:prose-xl ' + (isDark(theme) ? 'prose-invert' : '')
          }
        >
          <div dangerouslySetInnerHTML={contentHtml} />
          {/* {CTA && <CtaLink {...CTA} />} */}
        </div>
      </section>
    </ThemedSection>
  )
}

ParagraphStickyImageSection.propTypes = {
  section: PropTypes.shape({
    heading: PropTypes.string,
    content: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.object),
    fields: PropTypes.shape({
      contentImg: PropTypes.string,
    }),
    theme: PropTypes.string,
    layout: PropTypes.string,
    CTA: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
      openInNewTab: PropTypes.bool,
      download: PropTypes.bool,
    }),
  }),
  className: PropTypes.string,
}

ParagraphStickyImageSection.defaultProps = {
  section: {
    heading: '',
    content: '',
    images: [],
    fields: {
      contentImg: '',
    },
  },
  className: 'py-6 leading-loose',
}

export const query = graphql`
  fragment ParagraphSectionWithStickyImage on STRAPI__COMPONENT_SECTION_PARAGRAPH_WITH_STICKY_IMAGE {
    id
    strapi_component
    content
    heading
    # fields {
    #   contentImg
    # }
    images {
      gatsbyImageDataMock
    }
    # theme
    # layout
    # CTA {
    #   ...CtaLink
    # }
  }
`

export default ParagraphStickyImageSection
